/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowsOutLineVertical(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M224,128a8.00039,8.00039,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8.00039,8.00039,0,0,1,224,128ZM96,56h24V96a8,8,0,0,0,16,0V56h24a8.00066,8.00066,0,0,0,5.65723-13.65723l-32-32a8.003,8.003,0,0,0-11.31446,0l-32,32A8.00066,8.00066,0,0,0,96,56Zm64,144H136V160a8,8,0,0,0-16,0v40H96a8.00066,8.00066,0,0,0-5.65723,13.65723l32,32a8.00181,8.00181,0,0,0,11.31446,0l32-32A8.00066,8.00066,0,0,0,160,200Z" />
    </Svg>
  );
}

export default ArrowsOutLineVertical;
